import { useUser } from "@clerk/clerk-expo";
import SetupUserForm from "components/form/SetupUserForm";
import Container from "components/general/Container";
import HeaderMain from "components/general/Headers/HeaderMain";
import { MobileBottomTabs, MobileHeader } from "components/navigation";
import { ArrowLeftIcon, Box, Button, H2, HStack, Icon, SafeAreaView, View } from "components/ui";
import { Tabs, usePathname, useRouter, useSegments } from "expo-router";
import React, { useEffect, useRef } from "react";
import { Animated, Easing, Platform } from "react-native";
import { useGetCompanyQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { useScroll } from "utils/hooks/useScroll";
import { useSiteRegion } from "utils/hooks/useSiteSection";

export default function MainLayout() {
	const pathname = usePathname();
	const isMobile = useIsMobile();
	const region = useSiteRegion();
	const router = useRouter();
	const segments = useSegments();
	const { scrollDirection } = useScroll();
	const scrollY = useRef(new Animated.Value(0)).current;
	useEffect(() => {
		Animated.timing(scrollY, {
			toValue: scrollDirection === "up" ? 0 : -100,
			duration: 400,
			easing: Easing.bezier(0.25, 0.1, 0.25, 1),
			useNativeDriver: Platform.OS === "web" ? false : true,
		}).start();
	}, [scrollDirection]);

	function goBack(navigation: any) {
		const currentSegments = segments as string[];
		if (currentSegments.length === 4 && currentSegments[0] === "(pages)" && currentSegments[1] === "(inner)" && currentSegments[2] === "cart" && currentSegments[3] === "(step1)") {
			router.navigate("/");
		} else if (router.canGoBack()) {
			router.back();
		} else {
			navigation.navigate("index");
		}
	}

	const { isLoaded, isSignedIn, user } = useUser();

	const { data: company } = useGetCompanyQuery(undefined, {
  		skip: !isSignedIn,
	});

	let abconetVersion = null;
	if (isSignedIn && company) {
		abconetVersion = company.abconetVersion;
	}

	if (isSignedIn && user.publicMetadata && Object.keys(user.publicMetadata).length === 0) {
		return (
			<Container>
				<SetupUserForm />
			</Container>
		);
	}

	if (isSignedIn && process.env.NODE_ENV === "production" && abconetVersion === "1.0" && !(user?.publicMetadata?.isSuperAdmin)) {
		router.navigate("https://abconet.com.au/");
	}

	if (isSignedIn && user.publicMetadata && user.publicMetadata.companyData) {
		const companies = user.publicMetadata?.companyData || {};

		const isAu = Object.values(companies).some((company) => company.subsidiaryCollection?.includes(2));

		const isNz = Object.values(companies).some((company) => company.subsidiaryCollection?.includes(6));

		if (
			process.env.NODE_ENV === "production" &&
			window.location.hostname !== "staging--abcoweb.netlify.app"
			) {
			const shouldRedirectAU = isAu && region === "nz";
			const shouldRedirectNZ = isNz && region === "au";

			const skipRedirect = isAu && isNz;

			if (!skipRedirect) {
				if (shouldRedirectAU) {
				window.location.href = "https://new.abcopro.com.au";
				} else if (shouldRedirectNZ) {
				window.location.href = "https://abcopro.co.nz";
				}
			}
		
		}
	}

	return (
		<Tabs
			tabBar={() => <MobileBottomTabs />}
			screenOptions={{
				header: (props) => {
					if (isMobile) {
						switch (pathname) {
							case "/cart":
								return (
									<SafeAreaView borderBottomWidth={1} borderBottomColor="$neutral100" backgroundColor="$basicwhite" paddingHorizontal={16} paddingVertical={18}>
										<HStack space="xl" alignItems="center" mx="$0.5">
											<Button
												onPress={() => {
													goBack(props.navigation);
												}}
												paddingLeft={0}
											>
												<Icon color="$basicblack" as={ArrowLeftIcon} m="$2" size="lg" />
											</Button>
											<H2>Review Order</H2>
										</HStack>
									</SafeAreaView>
								);
						}
					}

					return (
						<Box>
							<Animated.View
								style={{
									position: "absolute",
									top: 0,
									width: "100%",
									transform: [
										{
											translateY: scrollY,
										},
									],
								}}
							>
								{!isMobile && (
									<View>
										<HeaderMain />
									</View>
								)}
							</Animated.View>
							<MobileHeader />
						</Box>
					);
				},
			}}
		></Tabs>
	);
}
